import { isStaanderPanelDoor } from "./layoutGeometry";

export const defaultMinDoorWidth = 600;
export const defaultMinPanelWidth = 150;
export const newLayoutMinWidth = 750;
export const standingDoorMinWidth = 750;
export const standingPanelMinWidth = 600;

export const getStaanderMinWidth = (doorCode: string): number =>
  isStaanderPanelDoor(doorCode) ? standingPanelMinWidth : standingDoorMinWidth;

export const getStandingLayoutMinWidth = (
  doorCode: string,
  hasStaander: boolean,
): number | undefined => {
  return hasStaander ? getStaanderMinWidth(doorCode) : undefined;
};
